module.exports = __webpack_public_path__ + "public/images/exploring-science.338e8b3ca2d4bfdf00fd53c19aaa500d.jpg";